export default __webpack_public_path__ + "941cfedd3449718c7caf562d96ddce87.png";